var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationIc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 221.50599 297.00101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "location") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M148.5,0A110.89988,110.89988,0,0,0,37.747,110.797c0,91.026,99.729,179.905,103.976,183.645a10.25461,10.25461,0,0,0,13.555,0c4.245-3.739,103.975-92.618,103.975-183.645A110.89986,110.89986,0,0,0,148.5,0Zm0,272.689c-22.049-21.366-90.243-93.029-90.243-161.892a90.243,90.243,0,1,1,180.486,0C238.743,179.659,170.549,251.322,148.5,272.689Z",
    transform: "translate(-37.747)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M148.5,59.183a51.61513,51.61513,0,1,0,51.274,51.614A51.50287,51.50287,0,0,0,148.5,59.183Zm0,82.718a31.10587,31.10587,0,1,1,30.765-31.104A30.97073,30.97073,0,0,1,148.5,141.901Z",
    transform: "translate(-37.747)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIc);
export default __webpack_public_path__ + "static/media/location-ic.83c7afeb2a45e2dfa58460d7ce38361b.svg";
export { ForwardRef as ReactComponent };